module.exports = __webpack_public_path__ + "static/media/excelwhite.408c0e71.svg";